import { SaveAlt } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import React from 'react';
import Swal from 'sweetalert2';
import { formatDateTime } from '../../../../utils/dateUtils';
import dayjs from 'dayjs';

const ExportAll = (props) => {
  const { taxData,searchType,bookingNumber,startDate,endDate,year } = props;

  // Define custom headers and their corresponding data mapping

  const exportMapping = [
    {
      header: 'SL. NO.',
      value: (row) => ``
    },
    {
      header: 'Branch ',
      value: (row) => ``
    },
    {
      header: 'Invoice Type',
      value: (row) => `CuDel Expert Wallet Invoice`
    },
    {
      header: 'Invoice No',
      value: (row) => `TXN-${row.txnId}`
    },
    {
      header: 'Date',
      value: (row) => formatDateTime(row.createdAt)
    },
    {
      header: 'State Code',
      value: (row) => `${row.stateCode}`
    },
    {
      header: 'Client Name',
      value: (row) => `${row.expertName ||''}`
    },
    {
      header: 'Client GST Number',
      value: (row) => `${row.gstNumber || ''}`
    },
    {
      header: 'Client PAN NUMBER',
      value: (row) => `${row.panNumber || ''}`
    },
    {
      header: 'Client Adress',
      value: (row) => `${row.serviceAddress}`
    },
    {
      header: 'Narration',
      value: (row) => `${''}`
    },
    {
      header: 'TAXABLE',
      value: (row) => `${row.taxableAmount || ''}`
    },
    {
      header: 'IGST',
      value: (row) => `${row.igst || ''}`
    },
    {
      header: 'CGST',
      value: (row) => `${row.cgst || ''}`
    },
    {
      header: 'SGST',
      value: (row) => `${row.sgst || ''}`
    },
    {
      header: 'Total GST',
      value: (row) => `${row.totalGst || ''}`
    },
    {
      header: 'Total Amount',
      value: (row) => `${row.invoiceAmount || ''}`
    },
    {
      header: 'Less Advance Amt',
      value: (row) => `${row.gstNumber || ''}`
    },
    {
      header: 'Final Amount',
      value: (row) => `${row.gstNumber || ''}`
    },
    {
      header: 'Rate',
      value: (row) => `${row.gstNumber || ''}`
    },
    {
      header: 'ACK',
      value: (row) => `${row.gstNumber || ''}`
    },
    {
      header: 'IRN',
      value: (row) => `${row.gstNumber || ''}`
    },
    {
      header: 'SAC Code',
      value: (row) => `${row.gstNumber || ''}`
    },
    {
      header: 'Our Entity Name',
      value: (row) => `CUDEL DELIGHT SOLUTIONS PRIVATE LIMITED`
    },
    {
      header: 'Entity GST number',
      value: (row) => `07AAHCC6070E1ZT`
    },
    {
      header: 'REMARKS',
      value: (row) => `Cudel Service Expert Wallet Invoice`
    },
    
    
    
    // { 
    //   header: 'Parent Service',
    //   value: (row) => `${row?.parentService?.title || ''}`
    // },
    // {
    //   header: 'Sub Category',
    //   value: (row) => row.ServiceCategoryRels[0]?.ServiceCategory?.title || ''
    // },
    // {
    //   header: 'Category',
    //   value: (row) => row.ServiceCategoryRels[0]?.ServiceCategory?.parentCategory?.title || ''
    // },
    // {
    //   header: 'Status',
    //   value: (row) => row.isActive ? 'Active' : 'Inactive'
    // },
    
  ];

  const handleExportAllRows = async () => {
    try {
      // Swal.fire({
      //   title: 'Exporting Data',
      //   text: 'Please wait while we prepare your download...',
      //   icon: 'info',
      //   allowOutsideClick: false,
      //   didOpen: () => {
      //     Swal.showLoading();
      //   }
      // });

      // Transform data using custom mapping
      const exportData = taxData.map(row => {
        return exportMapping.reduce((acc, field) => {
          acc[field.header] = field.value(row);
          return acc;
        }, {});
      });

      // Create CSV content
      const headers = exportMapping.map(field => `"${field.header}"`).join(',');
      const csvContent = exportData.map(row => 
        exportMapping.map(field => 
          `"${String(row[field.header] ?? '').replace(/"/g, '""')}"`
        ).join(',')
      );

      csvContent.unshift(headers);

      // Create and download file
      const csvString = csvContent.join('\n');
      const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const fileName = searchType === 'year' 
                      ? `Tax_Report_${year}` 
                      : searchType === 'booking' 
                          ? `Tax_Report_${bookingNumber}` 
                          : `Tax_Report_${dayjs(startDate).format('DD-MM-YYYY')}_to_${dayjs(endDate).format('DD-MM-YYYY')}`;
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${fileName}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      Swal.fire({
        title: 'Export Successful',
        html: `
          <p>If download doesn't start automatically, click on provided link:
          <a href="${url}" download="ServiceExpert-report.csv" style="color: blue; text-decoration: underline;">
            Download CSV
          </a></p>
        `,
        icon: 'success',
        showConfirmButton: true,
        confirmButtonText: 'Close'
      });

    } catch (error) {
      console.error('Export failed', error);
      
      Swal.fire({
        title: 'Export Failed',
        text: 'There was an issue exporting the data. Please try again.',
        icon: 'error'
      });
    }
  };

  return (
    <Box>        
      <Button 
        onClick={handleExportAllRows}
        startIcon={<SaveAlt />}
        sx={{textTransform:'none'}}
      >
        Export
      </Button>      
    </Box>
  );
}

export default ExportAll;